import { withTranslation as withTranslation_REMOVE_THIS_IMPORT_IN_SPRINT_77 } from '@application/i18n/with_translation';

export const withTranslation = withTranslation_REMOVE_THIS_IMPORT_IN_SPRINT_77;
